import {
  downloadCertificate,
  generateCertificateWithCustomFields,
} from '../../requests';
import { ReportType } from '../../types';

type BaseHandlerParams = {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
};

type ReportDownloadHandlerParams = BaseHandlerParams & {
  afterDownload?: ({ data, error }: any) => void;
  beforeDownload?: () => void;
};

export const createReportDownloadHandler = ({
  beforeDownload = () => null,
  afterDownload = () => null,
  onError = () => null,
  onSuccess = () => null,
}: ReportDownloadHandlerParams) => {
  return async (studyPlanEnrollmentId: number, reportType: ReportType) => {
    beforeDownload();
    const { data, error, status } = await downloadCertificate(
      studyPlanEnrollmentId,
      reportType,
    );
    if (error) {
      onError(error);
    } else {
      onSuccess(data);
    }

    afterDownload({ data, error, status: status ?? error });
  };
};

export const createCertificateWithCustomFieldsHandler = ({
  beforeDownload = () => null,
  afterDownload = () => null,
  onError = () => null,
  onSuccess = () => null,
}: ReportDownloadHandlerParams) => {
  return async (
    studyPlanEnrollmentId: number,
    reportType: ReportType,
    customFields: Record<string, any>,
  ) => {
    beforeDownload();
    const { data, error, status } = await generateCertificateWithCustomFields(
      studyPlanEnrollmentId,
      reportType,
      customFields,
    );
    if (error) {
      onError(error);
    } else {
      onSuccess(data);
    }

    afterDownload({ data, error, status: status ?? error });
  };
};
